import { render, staticRenderFns } from "./MaterialApproval.vue?vue&type=template&id=79979da4&scoped=true"
import script from "./MaterialApproval.vue?vue&type=script&lang=js"
export * from "./MaterialApproval.vue?vue&type=script&lang=js"
import style0 from "@/styles/approval-status.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MaterialApproval.vue?vue&type=style&index=1&id=79979da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79979da4",
  null
  
)

export default component.exports